/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Stat_ExercisesInputs */

const en_us2_search_stat_exercises = /** @type {(inputs: Search_Stat_ExercisesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`exercises`)
};

const pt_br2_search_stat_exercises = /** @type {(inputs: Search_Stat_ExercisesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`exercícios`)
};

const es_419_search_stat_exercises = /** @type {(inputs: Search_Stat_ExercisesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ejercicios`)
};

const pt_pt2_search_stat_exercises = /** @type {(inputs: Search_Stat_ExercisesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`exercícios`)
};

const fr_fr2_search_stat_exercises = /** @type {(inputs: Search_Stat_ExercisesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`exercices`)
};

const de_de2_search_stat_exercises = /** @type {(inputs: Search_Stat_ExercisesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übungen`)
};

const it_it2_search_stat_exercises = /** @type {(inputs: Search_Stat_ExercisesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`esercizi`)
};

/**
* | output |
* | --- |
* | "exercises" |
*
* @param {Search_Stat_ExercisesInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_stat_exercises = /** @type {((inputs?: Search_Stat_ExercisesInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Stat_ExercisesInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_stat_exercises(inputs)
	if (locale === "es-419") return es_419_search_stat_exercises(inputs)
	if (locale === "pt-PT") return pt_pt2_search_stat_exercises(inputs)
	if (locale === "fr-FR") return fr_fr2_search_stat_exercises(inputs)
	if (locale === "de-DE") return de_de2_search_stat_exercises(inputs)
	if (locale === "it-IT") return it_it2_search_stat_exercises(inputs)
	return en_us2_search_stat_exercises(inputs)
});
export { search_stat_exercises as "search.stat_exercises" }